import { Injectable } from '@angular/core';

import { BuiltInCheckInSound } from '../../models/check-in-sound';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class CheckInSoundService {
  /**
   * A service providing access to check-in sounds.
   */

  constructor(
    private apiService: ApiService
  ) {}

  getBuiltInCheckInSounds(): Promise<BuiltInCheckInSound[]> {
    return this.apiService.getFromAPI<BuiltInCheckInSound[]>(
      'gym-endpoints/built-in-check-in-sounds/'
    );
  }
}
